import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';
import { useGetPromotionsQuery } from '@bo-services/promotionsApi';
import { useMemo } from 'react';

export const PromotionsSelect = ({
  containerClassName = '',
  className = '',
  iconOnly = false,
  label = undefined,
  onChange,
  value,
  zIndex = undefined
}: {
  containerClassName?: string;
  className?: string;
  iconOnly?: boolean;
  label?: string;
  onChange: (promotionId: string) => void;
  value: string;
  zIndex?: number;
}) => {
  const { data: promotions, isLoading } = useGetPromotionsQuery({
    page: 0,
    perPage: 10
  });

  const promotionValues = useMemo<SelectOption[]>(
    () =>
      promotions
        ? promotions.data.map((promo) => ({
            key: promo.id,
            name: `${promo.id} - ${promo.attributes.name}`,
            value: promo.id
          }))
        : [],
    [promotions]
  );

  const handleOnChange = (promotionId: SelectOption) => {
    onChange(promotionId.value);
  };

  if (isLoading) {
    return (
      <div className="flex flex-col gap-y-2">
        <div className="text-soClean-160/50 rounded-md text-xs uppercase leading-6">
          Promotion
        </div>
        <div className="border-soFresh-190/50 h-10 min-w-52 animate-pulse rounded border border-dashed" />
      </div>
    );
  }

  return (
    <>
      {label && (
        <label className="text-soClean-100 rounded-md text-xs uppercase leading-6">
          {label}
        </label>
      )}
      <Select
        containerClassName={containerClassName}
        className={className}
        iconOnly={iconOnly}
        optionsClassName="!t-6"
        label={label!}
        onChange={handleOnChange}
        options={promotionValues}
        size="small"
        testId="promotions-select"
        value={value}
        zIndex={zIndex}
        portal
      />
    </>
  );
};
